import { defineStore } from "pinia";
import { createClient } from "@/sdk";
import type {
  WebhusetConstantsOrderAgreementPeriodTypeItem,
  WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto,
} from "~/sdk/generated/models";

export const useVpsAddOnCatalogStore = defineStore("vps-addon-catalog", () => {
  const cartStore = useCartStore();
  const config = useRuntimeConfig();

  const client = createClient(config.public.apiServer);

  const isReady = ref(false);
  const catalog =
    ref<
      WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse_CatalogVpsAddOnItemResultRestDto[]
    >();

  watch(
    () => cartStore.coupon,
    () => {
      isReady.value = false;
      console.log("Coupon changed", cartStore.coupon);
    }
  );

  const fetchCatalog = async () => {
    const addons = await client.catalog.vpsaddons.get({
      queryParameters: {
        coupon: cartStore.coupon,
      },
    });

    catalog.value = addons?.products;
    isReady.value = true;
  };

  watch(
    isReady,
    async () => {
      if (!isReady.value) {
        await fetchCatalog();
      }
    },
    {
      immediate: true,
    }
  );

  return {
    isReady,
    catalog,
    getByType: (addOnType: number) =>
      catalog.value?.find((item) => item.addOnType === addOnType),
    getSubscriptionByAddOnId: (addOnId: number) => {
      return catalog.value
        ?.flatMap((item) => item.subscriptions)
        .find((subscription) => subscription?.addOnId === addOnId);
    },
    getSubscriptionsByAddOnTypeAndAgreementPeriod: (
      addOnTypeId: number,
      agreementPeriod: WebhusetConstantsOrderAgreementPeriodTypeItem
    ) => {
      return catalog.value
        ?.filter((i) => i.addOnType == addOnTypeId)
        ?.flatMap((item) => item.subscriptions)
        .filter(
          (subscription) =>
            subscription?.agreementPeriodType === agreementPeriod
        );
    },
  };
});
